/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateMfaRequest} from '../models/UpdateMfaRequest';
import type {UpdateMfaResponse} from '../models/UpdateMfaResponse';

export interface BulkMfaStatusUpdateProgress$Request {
    id: string;
}

export interface BulkMfaStatusUpdateProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkMfaStatusUpdateProgressRequest = createAction<PayloadData<void, BulkMfaStatusUpdateProgress$Request>>('BULK_UPDATE_MFA_STATUS__BULK_MFA_STATUS_UPDATE_PROGRESS__REQUEST');
export const bulkMfaStatusUpdateProgressSuccess = createAction<PayloadData<BulkProgress, BulkMfaStatusUpdateProgress$Request>>('BULK_UPDATE_MFA_STATUS__BULK_MFA_STATUS_UPDATE_PROGRESS__SUCCESS');
export const bulkMfaStatusUpdateProgressFailure = createAction<PayloadData<Error, BulkMfaStatusUpdateProgress$Request, true>>('BULK_UPDATE_MFA_STATUS__BULK_MFA_STATUS_UPDATE_PROGRESS__FAILURE');

export const bulkMfaStatusUpdateProgressActions = [
    bulkMfaStatusUpdateProgressRequest,
    bulkMfaStatusUpdateProgressSuccess,
    bulkMfaStatusUpdateProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkMfaStatusUpdateProgress = (meta: BulkMfaStatusUpdateProgress$Request, config?: BulkMfaStatusUpdateProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: bulkMfaStatusUpdateProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/mfa-status/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetMfaStatusUpdateResult$Request {
    id: string;
}

export interface GetMfaStatusUpdateResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMfaStatusUpdateResultRequest = createAction<PayloadData<void, GetMfaStatusUpdateResult$Request>>('BULK_UPDATE_MFA_STATUS__GET_MFA_STATUS_UPDATE_RESULT__REQUEST');
export const getMfaStatusUpdateResultSuccess = createAction<PayloadData<UpdateMfaResponse, GetMfaStatusUpdateResult$Request>>('BULK_UPDATE_MFA_STATUS__GET_MFA_STATUS_UPDATE_RESULT__SUCCESS');
export const getMfaStatusUpdateResultFailure = createAction<PayloadData<Error, GetMfaStatusUpdateResult$Request, true>>('BULK_UPDATE_MFA_STATUS__GET_MFA_STATUS_UPDATE_RESULT__FAILURE');

export const getMfaStatusUpdateResultActions = [
    getMfaStatusUpdateResultRequest,
    getMfaStatusUpdateResultSuccess,
    getMfaStatusUpdateResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMfaStatusUpdateResult = (meta: GetMfaStatusUpdateResult$Request, config?: GetMfaStatusUpdateResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getMfaStatusUpdateResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/mfa-status`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopUpdateMfaJob$Request {
    id: string;
}

export interface StopUpdateMfaJob$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopUpdateMfaJobRequest = createAction<PayloadData<void, StopUpdateMfaJob$Request>>('BULK_UPDATE_MFA_STATUS__STOP_UPDATE_MFA_JOB__REQUEST');
export const stopUpdateMfaJobSuccess = createAction<PayloadData<void, StopUpdateMfaJob$Request>>('BULK_UPDATE_MFA_STATUS__STOP_UPDATE_MFA_JOB__SUCCESS');
export const stopUpdateMfaJobFailure = createAction<PayloadData<Error, StopUpdateMfaJob$Request, true>>('BULK_UPDATE_MFA_STATUS__STOP_UPDATE_MFA_JOB__FAILURE');

export const stopUpdateMfaJobActions = [
    stopUpdateMfaJobRequest,
    stopUpdateMfaJobSuccess,
    stopUpdateMfaJobFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopUpdateMfaJob = (meta: StopUpdateMfaJob$Request, config?: StopUpdateMfaJob$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopUpdateMfaJobActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/mfa-status`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateMfaStatus$Request {
    updateMfaRequest: UpdateMfaRequest;
    reason?: string;
}

export interface UpdateMfaStatus$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateMfaStatusRequest = createAction<PayloadData<void, UpdateMfaStatus$Request>>('BULK_UPDATE_MFA_STATUS__UPDATE_MFA_STATUS__REQUEST');
export const updateMfaStatusSuccess = createAction<PayloadData<string, UpdateMfaStatus$Request>>('BULK_UPDATE_MFA_STATUS__UPDATE_MFA_STATUS__SUCCESS');
export const updateMfaStatusFailure = createAction<PayloadData<Error, UpdateMfaStatus$Request, true>>('BULK_UPDATE_MFA_STATUS__UPDATE_MFA_STATUS__FAILURE');

export const updateMfaStatusActions = [
    updateMfaStatusRequest,
    updateMfaStatusSuccess,
    updateMfaStatusFailure
] as const;

/**
 * @param {UpdateMfaRequest} meta.updateMfaRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateMfaStatus = (meta: UpdateMfaStatus$Request, config?: UpdateMfaStatus$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: updateMfaStatusActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/users/mfa-status`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateMfaRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

